<template lang="pug">
  card-info(title="Assinantes ativos" icon="fas fa-dollar-sign")
    .card-body(slot="card-body")
      | Retorna um arquivo #[code .csv] com as informações dos usuários com assinatura ativa
    .card-footer.text-right(slot="card-footer")
      a.btn.btn-error.btn-sm(:class="{ loading }" :disabled="loading" @click="runReport")
        i.fas.fa-play
        |  Gerar relatório
</template>

<script>
import csvReports from '@/services/csvReports'

export default {
  data() {
    return { loading: false }
  },
  methods: {
    async runReport() {
      try {
        this.loading = true
        await csvReports.activeSubscribers()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
